import { type Analytics, getAnalytics } from 'firebase/analytics';
import { logEvent } from 'firebase/analytics';
import { type FirebaseApp, initializeApp } from 'firebase/app';

import { ENV } from './common/app/env';

const firebaseConfig = {
  apiKey: ENV.FIREBASE_API_KEY,
  authDomain: ENV.FIREBASE_AUTH_DOMAIN,
  projectId: ENV.FIREBASE_PROJECT_ID,
  storageBucket: ENV.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: ENV.FIREBASE_MESSAGING_SENDER_ID,
  appId: ENV.FIREBASE_APP_ID,
  measurementId: ENV.FIREBASE_MEASUREMENT_ID,
};

const firebase: FirebaseApp = initializeApp(firebaseConfig);

const analytics: Analytics | null =
  ENV.NODE_ENV === 'production' ? getAnalytics(firebase) : null;

type FirebaseEvents =
  | 'purchase'
  | 'boost_vip_activated'
  | 'boost_free_activated'
  | 'boost_ads_activated'
  | 'boost_paid_activated'
  | 'currency_spent'
  | 'boost_combined';

interface BoostActivatedPayload {
  duration: number;
  multiplier: number;
  affected_plant: string;
  level: number;
}

interface CurrencySpentEventPayload {
  currency_type: string;
  amount: number;
  reason: string;
  affected_plant: string;
  building_id: string;
}

interface BoostCombinedPayload {
  total_multiplier: number;
  boost_free_active: boolean;
  boost_ads_active: boolean;
  affected_plant: string;
  level: number;
  duration: number;
}

interface PurchasePayloadType {
  currency: string;
  value: number;
  item_name: string;
}

interface FirebaseEventsPayload {
  purchase: PurchasePayloadType;
  boost_vip_activated: BoostActivatedPayload;
  boost_free_activated: BoostActivatedPayload;
  boost_ads_activated: BoostActivatedPayload;
  boost_paid_activated: BoostActivatedPayload;
  boost_combined: BoostCombinedPayload;
  currency_spent: CurrencySpentEventPayload;
}

const firebaseLogEvent = <T extends FirebaseEvents>(
  event: T,
  payload: FirebaseEventsPayload[T],
): void => {
  if (analytics) {
    const stringEvent = event as string;
    logEvent(analytics, stringEvent, payload);
  }
};

export {
  analytics,
  type BoostActivatedPayload,
  type BoostCombinedPayload,
  type CurrencySpentEventPayload,
  type FirebaseEvents,
  firebaseLogEvent,
};
